import { z } from 'zod';

import { EMAIL_CONSTANTS, EMAIL_MESSAGES } from '../constants/email';

export const emailSchema = z.object({
  email: z.string().max(EMAIL_CONSTANTS.MAX_LENGTH, EMAIL_MESSAGES.MAX_LENGTH).email(EMAIL_MESSAGES.INVALID)
});

export type EmailFormValues = z.infer<typeof emailSchema>;
